import React, { useContext } from 'react';
import { StoreContext } from '@/store/storeProvider';
import { Sun, Moon, Laptop, Palette } from 'lucide-react';

export const AppearanceSettings = () => {
  const { theme, setTheme } = useContext(StoreContext);

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="bg-white dark:bg-neutral-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-neutral-700">
        <div className="flex items-center gap-3 mb-6">
            <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                <Palette className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Appearance</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                    Customize how the application looks on your device
                </p>
            </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl">
            <button 
                className={`p-6 border rounded-xl flex flex-col items-center gap-3 transition-all duration-200 ${theme === 'light' ? 'ring-2 ring-blue-500 border-transparent bg-blue-50 dark:bg-blue-900/20' : 'border-gray-200 dark:border-neutral-600 hover:border-blue-300 dark:hover:border-blue-700 hover:bg-gray-50 dark:hover:bg-neutral-750'}`}
                onClick={() => setTheme('light')}
                aria-pressed={theme === 'light'}
                data-testid="settings-appearance-light"
            >
                <div className={`p-3 rounded-full ${theme === 'light' ? 'bg-blue-100 dark:bg-blue-900' : 'bg-gray-100 dark:bg-neutral-700'}`}>
                    <Sun className={`h-6 w-6 ${theme === 'light' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'}`} />
                </div>
                <span className={`font-medium ${theme === 'light' ? 'text-blue-900 dark:text-blue-100' : 'text-gray-700 dark:text-gray-300'}`}>Light Mode</span>
            </button>

            <button 
                className={`p-6 border rounded-xl flex flex-col items-center gap-3 transition-all duration-200 ${theme === 'dark' ? 'ring-2 ring-blue-500 border-transparent bg-blue-50 dark:bg-blue-900/20' : 'border-gray-200 dark:border-neutral-600 hover:border-blue-300 dark:hover:border-blue-700 hover:bg-gray-50 dark:hover:bg-neutral-750'}`}
                onClick={() => setTheme('dark')}
                aria-pressed={theme === 'dark'}
                data-testid="settings-appearance-dark"
            >
                 <div className={`p-3 rounded-full ${theme === 'dark' ? 'bg-blue-100 dark:bg-blue-900' : 'bg-gray-100 dark:bg-neutral-700'}`}>
                    <Moon className={`h-6 w-6 ${theme === 'dark' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'}`} />
                </div>
                <span className={`font-medium ${theme === 'dark' ? 'text-blue-900 dark:text-blue-100' : 'text-gray-700 dark:text-gray-300'}`}>Dark Mode</span>
            </button>

            <button 
                className={`p-6 border rounded-xl flex flex-col items-center gap-3 transition-all duration-200 ${theme === 'system' ? 'ring-2 ring-blue-500 border-transparent bg-blue-50 dark:bg-blue-900/20' : 'border-gray-200 dark:border-neutral-600 hover:border-blue-300 dark:hover:border-blue-700 hover:bg-gray-50 dark:hover:bg-neutral-750'}`}
                onClick={() => setTheme('system')}
                aria-pressed={theme === 'system'}
                data-testid="settings-appearance-system"
            >
                 <div className={`p-3 rounded-full ${theme === 'system' ? 'bg-blue-100 dark:bg-blue-900' : 'bg-gray-100 dark:bg-neutral-700'}`}>
                    <Laptop className={`h-6 w-6 ${theme === 'system' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'}`} />
                </div>
                <span className={`font-medium ${theme === 'system' ? 'text-blue-900 dark:text-blue-100' : 'text-gray-700 dark:text-gray-300'}`}>System Default</span>
            </button>
        </div>
      </div>
    </div>
  );
};
